import { type InvalidateQueryFilters } from '@tanstack/react-query';
import { usePatchCustomerTags } from '@hungryroot/rest-hooks';

interface Options {
  invalidationKeys?: InvalidateQueryFilters[];
}

export function usePatchCustomerTag(options: Options = {}) {
  const mutation = usePatchCustomerTags({
    invalidationKeys: options.invalidationKeys,
  });
  return mutation as ReturnType<typeof usePatchCustomerTags>;
}
